import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAllMenuItemsRequest = async (
  token,
  organizationId,
  restaurantId,
  defaultOrganizatoinLanguage
) => {
  const url =
    apiURl +
    `items/getall?organizationId=${organizationId}&restaurantId=${restaurantId}&language=${defaultOrganizatoinLanguage}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const getAllCategoriesRequest = async (token, organizationId) => {
  const url = apiURl + `menucategories/getall?organizationId=${organizationId}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const editMenuItemRequest = async (token, menuItem) => {
  const url = apiURl + `items/edit`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(menuItem),
  };
  return fetchAndReturn(url, parameters);
};

const editCategoryRequest = async (token, menuItem) => {
  const url = apiURl + `menucategories/edit`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(menuItem),
  };
  return fetchAndReturn(url, parameters);
};

const syncMenuConfigurationImagesRequest = async (token, organizationId) => {
  const url = apiURl + `mymenu/images/sync?organizationId=${organizationId}`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const getMenuItemImageRequest = async (token, organizationId, itemId) => {
  const url =
    apiURl + `items/image?organizationId=${organizationId}&ItemId=${itemId}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const getAllItemsTagsRequest = async (token, organizationId) => {
  const url = apiURl + `tags/getAll?organizationId=${organizationId}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const editTagRequest = async (token, tag) => {
  const url = apiURl + `tags/update`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(tag),
  };
  return fetchAndReturn(url, parameters);
};

const updateMenuItemImagesRequest = async (token, imagesState) => {
  const url =
    apiURl +
    `items/images?organizationId=` +
    localStorage.getItem("organizationId");

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(imagesState),
  };
  return fetchAndReturn(url, parameters);
};

export {
  getAllMenuItemsRequest,
  getAllCategoriesRequest,
  editMenuItemRequest,
  editCategoryRequest,
  syncMenuConfigurationImagesRequest,
  getMenuItemImageRequest,
  getAllItemsTagsRequest,
  editTagRequest,
  updateMenuItemImagesRequest,
};
